'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlFieldError", function ($translate) {
  return {
    restrict: "A",
    scope: true,
    link: function link($scope, $el, $attrs) {
      var fieldName = $attrs.tlFieldError;

      //console.log('Link '+fieldName);

      // le watch tel quel défini plus bas ne permet que des noms simples... sans profondeur
      if (fieldName.indexOf('.') !== -1) {
        console.error("tlFieldError a un un fieldname invalide : " + fieldName + ". Il ne doit pas y a voir de . dans le nom du champs, ceci n'est pas actuellement supporté");
      }

      // .tl-validated-input permet de définir directement un champs "custom" qui recevra la tooltip d'erreur et la couleur d'erreur
      var inputSelector = "input, select, textarea";
      $scope.$watch("errors." + fieldName, function (error) {
        if (error) {
          if ($el.find(inputSelector).val() !== undefined
          ///&& $el.find(inputSelector).first().val() !== "?" //  - ne marche pas quand un select input trouvés. pourquoi ?
          ) {
            //          console.log('Show error for '+fieldName);
            showError(error);
            return;
          } else {
            console.log('Cannot find field for tl-field-error : ' + fieldName, $el.find(inputSelector), $el.find(inputSelector).first().val());
          }
        }
        hideError();
      });

      // validation

      var showError = function showError(error) {
        $el.addClass("has-error");
        var element = $el.find(inputSelector);
        element.qtip({
          content: {
            text: error.message || $translate(error.messageKey)
          },
          position: {
            container: $el.closest("form"),
            my: 'top center',
            at: 'bottom center',
            adjust: {
              x: 3
            }
          },
          style: {
            classes: 'qtip-error'
          }
        });
      };
      var hideError = function hideError() {
        $el.removeClass("has-error");
        $el.find(inputSelector).qtip("destroy", true);
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tlFieldError.js
// module id = 2912
// module chunks = 13